import { AttemptCard, AttemptCardTitle, AttemptCardWrapper } from '@/components/custom/attempt';
import { Badge } from '@/components/ui/badge';
import { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

export default function SimpleDiscursiveQuestionCard({ question, examQuestions }) {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <AttemptCardWrapper className={`mt-6 p-0 ${true ? 'mb-3' : ''}`}>
      <AttemptCard
        className="items-center p-3"
        onClick={() => setIsExpanded(prev => !prev)}
      >
        <AttemptCardTitle>
          <Badge
            variant="bright"
            square
            size="sm"
            className="text-primary-dark"
          >
            Q{question?.id}
          </Badge>
        </AttemptCardTitle>

        <span className={`text-sm font-semibold text-primary-dark`}>Discursiva</span>

        <span className={`text-sm font-semibold ${question?.answer?.['is-correct'] ? 'text-success' : 'text-danger'}`}>{question?.answer?.['is-correct'] ? 'Acertou' : 'Errou'}</span>
        <div className="flex items-center gap-2">
          {isExpanded ? (
            <FiChevronUp
              className="text-primary"
              size={20}
            />
          ) : (
            <FiChevronDown
              className="text-primary"
              size={20}
            />
          )}
        </div>
      </AttemptCard>
      {isExpanded && (
        <div className="flex flex-col gap-2 bg-white p-2 text-sm text-primary-dark">
          <div className="rounded bg-neutral-bright p-3">
            <span className="font-bold">Enunciado</span>
            <p
              className="text-neutral"
              dangerouslySetInnerHTML={{ __html: examQuestions?.find(q => q.id == question?.['question-id'])?.description }}
            />
          </div>
          <div className="rounded bg-neutral-bright p-3">
            <span className="font-bold">Resposta do aluno</span>
            <p>{question?.content}</p>
            <div className="mt-3 rounded bg-white p-3 text-xs text-neutral-darker">
              <span className="font-bold text-neutral">Comentário do professor</span>
              <p>{question?.feedback || '--'}</p>
            </div>
          </div>
        </div>
      )}
    </AttemptCardWrapper>
  );
}
